// extracted by mini-css-extract-plugin
export default {"redIcon":"DocumentLeads_redIcon__0OTkv","greenIcon":"DocumentLeads_greenIcon__SH4HY","documentLead":"DocumentLeads_documentLead__DmSkb"};